import './footer.scss';
import { Version } from '../Version/Version';

export const Footer = () => {
  return (
    <footer className="myday-footer">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span>LifeLog ©{new Date().getFullYear()} Created by Midteide Consulting AS</span>
        <Version />
      </div>
    </footer>
  );
};
